import { useForm } from 'vee-validate';
import type { PackageProperty } from '@/models/package';
import { useApi } from './useApi';

export const useCustomPackageForm = () => {
  const packageProps = ref<PackageProperty[]>([]);

  const { validate, controlledValues } = useForm();

  const values = computed(() => controlledValues.value);

  const loadPackageProps = async () => {
    const { data, error } = await useApi<PackageProperty[]>('/custom-package');

    if (error.value) return;

    packageProps.value = data.value;
  };

  return {
    loadPackageProps,
    validate,
    values,
    packageProps
  };
};
